import React from 'react';
import Search from './Search/Search';
import { HeaderCellWrapper } from './styled';

function HeaderCell({ column }) {
  const { title, key, searchProps } = column;

  return (
    <HeaderCellWrapper key={key}>
      {title}
        <Search {...searchProps} />
    </HeaderCellWrapper>
  );
}

export default HeaderCell;
